import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import LandingPageList from '../components/LandingPageList';
import LandingPageLoading from '../components/LandingPageLoading';
import LandingPageError from '../components/LandingPageError';

const LandingPages = ({ onShowFeedbackModal, onUpgradeClick }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUser();
    if (projectId) {
      fetchProject();
    } else {
      setLoading(false);
    }
  }, [projectId]);

  const fetchUser = async () => {
    try {
      const response = await fetch('/api/auth/me', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const userData = await response.json();
        setUser(userData.user);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  const fetchProject = async () => {
    try {
      setLoading(true);
      const response = await fetch(`/api/dashboard/projects/${projectId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        if (response.status === 404) {
          toast.error('Project not found');
          navigate('/dashboard');
          return;
        }
        throw new Error('Failed to fetch project');
      }

      const data = await response.json();
      setProject(data);
    } catch (error) {
      console.error('Error fetching project:', error);
      toast.error('Failed to load project');
      navigate('/dashboard');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (projectId) {
      navigate(`/dashboard/projects/${projectId}`);
    } else {
      navigate('/dashboard');
    }
  };

  if (loading) {
    return <LandingPageLoading />;
  }

  if (projectId && !project) {
    return (
      <LandingPageError
        title="Project Not Found"
        message="The project you are looking for does not exist."
        onBack={handleBack}
        showBackButton={true}
      />
    );
  }

  return (
    <LandingPageList 
      projectId={projectId} 
      onBack={handleBack}
      user={user}
      onShowFeedbackModal={onShowFeedbackModal}
      onUpgradeClick={onUpgradeClick}
    />
  );
};

export default LandingPages;
